import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text } from '@chakra-ui/react';
import { rem } from 'polished';
import { CircleWrapBg } from '../Background/CircleWrapSvg';
import { EllipseEmptyIcon } from '../icons/EllipseEmptyIcon';
import { EllipseIcon } from '../icons/EllipseIcon';
import { AnimatePresence, motion } from 'framer-motion';
export const StepsProgressBar = ({ items, currentItem, itemColor, highlightColor, topMargin = rem(0), isAnimated = false, enableVisualEffects = true, }) => {
    return (_jsxs(Flex, Object.assign({ w: "100%", alignItems: "center", mt: topMargin }, { children: [_jsx(Flex, Object.assign({ sx: {
                    width: items.length ? '80%' : '0%',
                    '@media (max-width: 992px)': {
                        width: items.length ? '90%' : '0%',
                    },
                } }, { children: items.map((item, index) => (_jsx(ProgressItem, { title: item.title, isFilled: items.findIndex((tempItem) => tempItem.id === currentItem) >=
                        index, itemColor: itemColor, widthPercentage: item.widthPercentage, mobileWidthPercentage: item.mobileWidthPercentage, isSelected: items.findIndex((item) => item.id === currentItem) === index, highlightColor: highlightColor, isAnimated: isAnimated, enableVisualEffects: enableVisualEffects }, item.id))) })), _jsx(Flex, { background: itemColor, opacity: 0.2, height: rem(1), sx: {
                    width: items.length ? '20%' : '100%',
                    '@media (max-width: 992px)': {
                        width: '10%',
                    },
                } })] })));
};
const ProgressItem = ({ itemColor, title, isFilled, widthPercentage, mobileWidthPercentage, isSelected, highlightColor, isAnimated = false, enableVisualEffects, }) => {
    const Ellipse = EllipseIcon({ fillColor: itemColor });
    const EllipseEmpty = EllipseEmptyIcon({ fillColor: itemColor });
    const container = {
        hidden: { x: -100 },
        show: {
            x: [-100, 10, 0],
            transition: {
                duration: 0.5,
            },
        },
    };
    const item = {
        hidden: { x: -100 },
        show: { x: [-100, 0], stiffness: 100 },
    };
    return (_jsxs(Flex, Object.assign({ alignItems: "center", position: "relative", sx: {
            width: widthPercentage,
            '@media (max-width: 992px)': {
                width: mobileWidthPercentage !== null && mobileWidthPercentage !== void 0 ? mobileWidthPercentage : widthPercentage,
            },
        } }, { children: [isAnimated ? (_jsx(AnimatePresence, Object.assign({ mode: "wait", initial: true }, { children: isSelected ? (_jsx(motion.div, Object.assign({ variants: container, initial: "hidden", animate: "show", style: { width: '100%' } }, { children: _jsx(motion.div, Object.assign({ variants: item }, { children: _jsx(Flex, { height: rem(1), background: itemColor, opacity: isFilled ? 1 : 0.2, width: "100%" }) })) }))) : (_jsx(Flex, { height: rem(1), background: itemColor, opacity: isFilled ? 1 : 0.2, width: "100%" })) }))) : (_jsx(Flex, { height: rem(1), background: itemColor, opacity: isFilled ? 1 : 0.2, width: "100%" })), _jsxs(Flex, Object.assign({ position: "relative" }, { children: [isFilled ? (_jsx(Ellipse, { width: rem(8) })) : (_jsx(EllipseEmpty, { width: rem(8), opacity: "0.2" })), _jsxs(Flex, Object.assign({ position: "absolute", top: rem(20), left: "50%", transform: "translate(-50%, -10%)" }, { children: [enableVisualEffects && isSelected && (_jsx(CircleWrapBg, { color: highlightColor })), _jsx(Text, Object.assign({ color: itemColor, opacity: isFilled ? 1 : 0.2, whiteSpace: "nowrap", sx: {
                                    px: rem(12),
                                    py: rem(8),
                                    fontSize: rem(14),
                                    display: 'flex',
                                    '@media (max-width: 992px)': {
                                        fontSize: rem(10),
                                    },
                                    '@media (max-width: 678px)': {
                                        fontSize: rem(10),
                                        px: rem(6),
                                        py: rem(4),
                                        display: isSelected ? 'flex' : 'none',
                                    },
                                } }, { children: title }))] }))] }))] })));
};
//# sourceMappingURL=StepsProgressBar.js.map